import React from 'react';

const AdminOverview = () => {
  return <div>AdminOverview</div>;
};

export default AdminOverview;
